if (!customElements.get('swiper-image-gallery')) {
    class Gallery extends HTMLElement {
      constructor() {
        super();
        this.startingIndex = this.dataset.startingIndex;
      }

      connectedCallback() {
        if (window.Swiper) {
          this.init();
          return;
        }
        document.querySelector('[data-swiper-script]').addEventListener('load', () => this.init());
      }

      init() {
        this.thumbs = new Swiper(this.querySelector('[data-thumbs]'), {
          slidesPerView: this.querySelector('[data-thumbs] .swiper-wrapper').childElementCount,
          watchSlidesProgress: true,
          direction: 'vertical',
        });

        this.gallery = new Swiper(this.querySelector('[data-gallery]'), {
          loop: false,
          spaceBetween: 0,
          initialSlide: Number(this.startingIndex || 0),
          keyboard: {
            enabled: true,
          },
          pagination: {
            el: this.querySelector('[data-pagination]'),
            type: 'fraction',
            formatFractionCurrent: function (number) {
                return number;
            },
            formatFractionTotal: function (number) {
                return number;
            },
            renderFraction: function (currentClass, totalClass) {
                return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
            }
          },
          navigation: {
            nextEl: this.querySelector('[data-next]'),
            prevEl: this.querySelector('[data-prev]'),
          },
          thumbs: {
            swiper: this.thumbs,
            slideThumbActiveClass: 'text-primaryDark',
          },
          zoom: {
            zoomedSlideClass: 'cursor-zoom-out'
          }
        });

        this.gallery.on('click', () => this.gallery.zoom.toggle());

        this.thumbs.update();
      }
    }
    customElements.define('swiper-image-gallery', Gallery);
  }